import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import block from 'bem-cn-lite';
import { DatePicker } from '@gravity-ui/date-components';
import { usePopoverAuxControls } from '../../hooks/usePopoverAuxControls';
import { Icon, Popup, Text } from '@gravity-ui/uikit';
import { Calendar, Xmark } from '@gravity-ui/icons';
import './SharedRangeDatePicker.scss';
const b = block('shared-range-date-picker');
export const SharedRangeDatePicker = ({ value, onChange, className, placeholder = 'Выберите даты', startLabel = 'С:', endLabel = 'До:', format = 'DD.MM.YYYY', presets = [], size = 'm' }) => {
    const { open, buttonRef, toggleOpen, closePopover } = usePopoverAuxControls();
    const [startDate, setStartDate] = useState(value.start);
    const [endDate, setEndDate] = useState(value.end);
    useEffect(() => {
        if (value) {
            setStartDate(value.start || null);
            setEndDate(value.end || null);
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
    }, [value]);
    function updateRange(newStart, newEnd) {
        let resultStart = newStart;
        let resultEnd = newEnd;
        resultStart = resultStart ? resultStart.startOf('day') : null;
        resultEnd = resultEnd ? resultEnd.endOf('day') : null;
        onChange({
            start: resultStart,
            end: resultEnd
        });
    }
    function handleStartDateChange(date) {
        setStartDate(date);
        updateRange(date, endDate);
    }
    function handleEndDateChange(date) {
        setEndDate(date);
        updateRange(startDate, date);
    }
    function handleClearDates(e) {
        e.stopPropagation();
        setStartDate(null);
        setEndDate(null);
        updateRange(null, null);
    }
    function applyPreset(preset) {
        const { start, end } = preset.getRange();
        setStartDate(start);
        setEndDate(end);
        updateRange(start, end);
    }
    return (_jsxs("div", { className: className, children: [_jsxs("div", { ref: buttonRef, className: b('date-container'), onClick: toggleOpen, children: [_jsx(Text, { variant: "body-1", color: startDate || endDate ? 'primary' : 'hint', children: startDate || endDate ? (_jsxs(_Fragment, { children: [startDate
                                    ? startDate.format
                                        ? startDate.format('DD.MM.YYYY')
                                        : ''
                                    : '', startDate && endDate ? ' — ' : startDate ? ' —' : '— ', endDate ? (endDate.format ? endDate.format('DD.MM.YYYY') : '') : ''] })) : (placeholder) }), _jsxs("div", { className: b('icon-container'), children: [(startDate || endDate) && (_jsx("div", { onClick: handleClearDates, children: _jsx(Icon, { data: Xmark, className: b('clear-icon') }) })), _jsx(Icon, { data: Calendar, className: b('calendar-icon') })] })] }), open && (_jsx(Popup, { anchorRef: buttonRef, open: open, onClose: closePopover, placement: "bottom", className: b('popup'), children: _jsxs("div", { className: b('popup-container'), children: [_jsxs("div", { className: b('date-picker-container'), children: [_jsx(DatePicker, { size: size, hasClear: true, placeholder: "\u0414\u0414.MM.\u0413\u0413\u0413\u0413", label: startLabel, value: startDate, onUpdate: handleStartDateChange, format: format }), _jsx(DatePicker, { size: size, hasClear: true, placeholder: "\u0414\u0414.MM.\u0413\u0413\u0413\u0413", label: endLabel, value: endDate, onUpdate: handleEndDateChange, format: format })] }), presets.length > 0 && (_jsx("div", { className: b('presets-container'), children: presets.map((preset) => (_jsx(Text, { variant: "body-1", onClick: () => applyPreset(preset), className: b('preset-item'), children: preset.label }, preset.label))) }))] }) }))] }));
};
